import { render, staticRenderFns } from "./BoxResult.vue?vue&type=template&id=01fea91a&scoped=true"
import script from "./BoxResult.vue?vue&type=script&lang=js"
export * from "./BoxResult.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=01fea91a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fea91a",
  null
  
)

export default component.exports